module.exports = __webpack_public_path__ + "img/graph2-w.df50d09f.svg";